import LeadActivitySettingsTab from './lead-activity-settings';

export default LeadActivitySettingsTab;
